<template>
  <div class="tagList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="标签名" size="small" v-model="params.name" class="param-input" clearable></el-input>
      <el-select v-model="params.types" size="small" @change="getTagList('status')" clearable>
        <el-option v-for="item in wonder" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getTagList">搜索</el-button>
      <el-button type="primary" size="small" @click="tagsAction('add')">+新增标签</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="types" label="种类" align="center"></el-table-column>
      <el-table-column prop="name" label="名称" align="center">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">{{'#' + scope.row.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="倒序" align="center"></el-table-column>
      <el-table-column prop="enable" label="开关" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <!--
      <el-table-column prop="sortCode" label="标签排序" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.sortCode || '未知'}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="success"
            class="el-icon-edit"
            size="mini"
            @click="tagsAction('edit',scope.row)"
          ></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 5"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <tag-action ref="tagAction" @handlerTagList="handlerTagList"></tag-action>
  </div>
</template>
<script>
import TagAction from "./components/addTag";
// import { sortEscape } from '@/utils/global'
import API from "@/api";
// import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      wonder: [
        {
          label: "默认",
          value: 0
        },
        {
          label: "最热",
          value: 1
        },
        {
          label: "最新",
          value: 2
        }
      ],
      params: {
        pageNumber: 1,
        pageSize: 5,
        name: "",
        types: ""
      }
    };
  },
  components: {
    TagAction
  },
  mounted() {
    this.getTagList();
    if (JSON.stringify(this.$route.query) !== "{}") {
      this.tagsAction("add", this.$route.query);
    }
  },
  methods: {
    // 请求tag列表数据
    getTagList(type) {
      if (type) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getRecmdList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].enable === false) {
                this.tableData[i].enable = "关闭";
              } else {
                this.tableData[i].enable = "开启";
              }
              if (this.tableData[i].types === 0) {
                this.tableData[i].types = "默认";
              }
              if (this.tableData[i].types === 1) {
                this.tableData[i].types = "最热";
              }
              if (this.tableData[i].types === 2) {
                this.tableData[i].types = "最新";
              }
            }

            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 数据排序
    // handleSortChange(column) {
    //   if (column.order) {
    //     this.params.value = sortEscape(column.order)
    //     this.params.key = column.prop;
    //   } else {
    //     this.params.value = ''
    //     this.params.key = '';
    //   }
    //   this.getTagList()
    // },
    // 分页条数发生变化时触发
    changeSize(number) {
      this.params.pageSize = number;
      this.getTagList();
    },
    // 当前页发生变化时触发
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getTagList();
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerTagList() {
      this.params.pageNumber = 1;
      this.params.pageSize = 5;
      this.getTagList();
    },
    // 删除tags
    remove(row) {
      if (row.isActive === true) {
        this.$message.error("当前标签为开启状态，不能删除！");
        return false;
      }
      this.$confirm("您确定要删除当前标签吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.deleteRecmdList({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getTagList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑tags
    tagsAction(type, data) {
      this.$refs.tagAction.open(type, data);
    }
  }
};
</script>


